import { useCallback } from "react";
import { useSaveUserMutation } from "../mutations/useSaveUser.mutation";
import { UserInterface } from "../../../interfaces/userInterface";

export const useSaveUser = () => {
  const saveMutation = useSaveUserMutation();

  const handleSave = useCallback(
    (values: UserInterface) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
